import PropTypes from 'prop-types';
/* istanbul ignore file */

export const SecurityContact = PropTypes.shape({
  default: PropTypes.bool,
  extension: PropTypes.string,
  errorMessage: PropTypes.string,
  helpText: PropTypes.string,
  inputType: PropTypes.oneOf(['', 'email', 'phone']),
  label: PropTypes.string,
  name: PropTypes.string,
  sent: PropTypes.bool,
  value: PropTypes.string,
  verified: PropTypes.bool
});

export default SecurityContact;
